import { Button, ButtonVariant } from '@/components/ui/button'
import { DownloadCloud, LucideProps } from 'lucide-react'
import Text from '../../text'
import { PropsWithChildren } from 'react'
import Link from 'next/link'

interface DownloadButtonProps extends PropsWithChildren {
  className?: string
  text?: string
  url?: string
  variant?: ButtonVariant
  iconConfig?: LucideProps
  asLink?: boolean
}
const DownloadButton = ({
  children,
  className,
  text,
  url = '',
  variant,
  iconConfig,
  asLink,
}: DownloadButtonProps) => {
  return (
    <Button asChild={asLink} variant={variant} className={className}>
      <Link href={url} className="flex items-center gap-2 uppercase">
        <DownloadCloud {...iconConfig} />

        <Text variant={'button'} uppercase className="no-underline">
          {text || children}
        </Text>
      </Link>
    </Button>
  )
}
export default DownloadButton
